var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandTschechien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "#e42a18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.969,28.161C4.506,25.487 3,21.918 3,18C3,14.082 4.506,10.513 6.969,7.84C7.108,7.689 7.25,7.541 7.396,7.396L13.348,11.706L18,18L7.396,28.604C7.251,28.459 7.108,28.311 6.969,28.161Z",
    fill: "#0069b3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.396,7.396C10.204,4.579 14.023,2.996 18,3C26.278,3 33,9.722 33,18L18,18L7.396,7.396Z",
    fill: "#f5f5f5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandTschechien);
export default __webpack_public_path__ + "static/media/land_tschechien.1ff9bf829b950d702eb7bb0ac6b81114.svg";
export { ForwardRef as ReactComponent };